import React, { useState } from 'react';
import { useWaitlistCount } from '../lib/waitlist';
import { WaitlistDialog } from './WaitlistDialog';
interface WaitlistFormProps {
  variant?: 'hero' | 'final';
  submitLabel: string;
}
export function WaitlistForm({
  variant = 'hero',
  submitLabel
}: WaitlistFormProps) {
  const [open, setOpen] = useState(false);
  const {
    count
  } = useWaitlistCount();
  const isFinal = variant === 'final';
  const counterText = count === null ? 'cargando lista de espera…' : `${count.toLocaleString('es-AR')} personas ya están en la lista de espera`;
  return <div className={isFinal ? 'mx-auto max-w-[440px]' : 'max-w-[460px]'} data-id="element-158">
      <button type="button" onClick={() => setOpen(true)} className={`w-full whitespace-nowrap rounded border-none bg-camel px-6 py-[15px] font-display text-sm tracking-wide text-espresso-2 transition-[background,transform] duration-150 hover:bg-camel-light active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-camel-light sm:w-auto`} data-id="element-159">
        {submitLabel}
      </button>

      {!isFinal && <p className="mt-3.5 text-[12.5px] text-white/45" data-id="element-160">
          Sin spam. Te avisamos el día que abrimos, nada más.
        </p>}

      <p className={`mt-2.5 font-mono text-[13px] text-camel-light ${isFinal ? 'text-center' : ''}`} data-id="element-161">
        {counterText}
      </p>

      <WaitlistDialog open={open} onClose={() => setOpen(false)} data-id="element-162" />
    </div>;
}